import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const bootstrap = async () => {
      const savedToken = localStorage.getItem('agency_os_token');
      if (!savedToken) {
        if (active) setLoading(false);
        return;
      }

      setToken(savedToken);
      try {
        const res = await authApi.me();
        if (!active) return;
        localStorage.setItem('agency_os_user', JSON.stringify(res.data));
        setUser(res.data);
      } catch {
        localStorage.removeItem('agency_os_token');
        localStorage.removeItem('agency_os_user');
        if (active) {
          setToken(null);
          setUser(null);
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    bootstrap();
    return () => { active = false; };
  }, []);

  const login = useCallback((tokenVal, userVal) => {
    localStorage.setItem('agency_os_token', tokenVal);
    localStorage.setItem('agency_os_user', JSON.stringify(userVal));
    setToken(tokenVal);
    setUser(userVal);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('agency_os_token');
    localStorage.removeItem('agency_os_user');
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
